import 'formdata-polyfill';
import axios from 'axios';
import {scrollWithOffset} from '../base/utils';

class Newsletter {
    constructor($newsletter) {
        this.$newsletter = $newsletter;

        if (!this.$newsletter) {
            return;
        }

        this.init();
    }

    init() {
        this.$container = this.$newsletter.querySelector('.container');
        this.$status = this.$newsletter.querySelector('.js-newsletter-status');

        this.$stepOne = this.$container.cloneNode(true);

        this.$newsletter.querySelector('.newsletter-close').addEventListener('click', this.close.bind(this));

        this.$newsletter.addEventListener('submit', e => {
            e.preventDefault();

            let $form = e.target;

            if ($form.classList.contains('newsletter-form-inline')) {
                this.submitStep1($form);
            } else if ($form.classList.contains('newsletter-form')) {
                this.submitStep2($form);
            }
        });
    }

    close() {
        document.body.classList.remove('newsletter-open');
        this.$newsletter.classList.remove('newsletter-full');
        this.$newsletter.classList.remove('newsletter-thank-you');
        this.$container.innerHTML = '';
        this.$container.insertAdjacentHTML('beforeend', this.$stepOne.innerHTML);
    }

    submitStep1($form) {
        let $email = $form.querySelector('[name="email"]'),
            email = $email.value;

        if (!email) {
            let $field = $email.closest('.field'),
                $msg = $field.querySelector('.error-message'),
                msg = $msg.dataset.msg;

            $field.classList.add('error');
            $email.setAttribute('aria-invalid', 'true');
            $msg.innerText = msg;
            $email.focus();
        } else {
            axios.get($form.getAttribute('action')).then(response => {
                if (response && response.status === 200) {
                    this.showFullForm(response.data, email);
                }
            });
        }
    }

    showFullForm(data, email) {
        document.body.classList.add('newsletter-open');

        this.$newsletterLang = this.$newsletter.getAttribute('data-lang');
        this.$newsletter.classList.add('newsletter-full');
        this.$container.innerHTML = '';
        this.$container.insertAdjacentHTML('beforeend', data);

        this.$newsletterForm = this.$newsletter.querySelector('.newsletter-form');
        this.$newsletterForm.setAttribute('action', this.$newsletterForm.getAttribute('action') + this.$newsletterLang);
        this.$newsletterForm.setAttribute('data-thank-you', this.$newsletterForm.getAttribute('data-thank-you') + this.$newsletterLang);

        this.$emailWrap = this.$container.querySelector('.newsletter-form-email');
        this.$emailTrigger = this.$container.querySelector('.js-newsletter-change-email');
        this.$emailPreview = this.$emailWrap.querySelector('.newsletter-form-email-preview');
        this.$emailField = this.$emailWrap.querySelector('[name="email"]');
        this.$phoneField = this.$container.querySelector('[name="phone"]');
        this.$emailPreview.innerHTML = email;
        this.$emailField.value = email;

        this.$categoryTriggers = this.$container.querySelectorAll('.js-newsletter-category-trigger');

        this.$emailTrigger.addEventListener('click', this.toggleEmailPreview.bind(this));

        for (let $categoryTrigger of this.$categoryTriggers) {
            $categoryTrigger.addEventListener('change', this.toggleCategoryFields.bind(this));
        }

        this.$phoneField.addEventListener('input', this.toggleCategoryFields.bind(this));

        this.$status.innerText = 'Zapis na newsletter: krok drugi';
    }

    toggleEmailPreview() {
        this.$emailWrap.classList.toggle('edit');
    }

    toggleCategoryFields() {
        
        let $phone = this.$phoneField.value != '',
            $business = this.$container.querySelector('.js-newsletter-category-trigger[value="dla-biznesu"]').checked;

        if ($business) {
            this.$newsletterForm.classList.add('business-active');
            var buisnessInputs = this.$container.querySelectorAll('.newsletter-form-business-additional input');
            [...buisnessInputs].forEach((input) => {
                input.removeAttribute('disabled');
            });
            this.togglePhoneConsent($phone);
        } else {
            this.$newsletterForm.classList.remove('business-active');
            var buisnessInputs = this.$container.querySelectorAll('.newsletter-form-business-additional input');
            [...buisnessInputs].forEach((input) => {
                input.setAttribute('disabled', 'disabled');
            });
            this.togglePhoneConsent(false);
        }

    }

    togglePhoneConsent(show){
        if (show) {
            this.$newsletterForm.classList.add('phone-active');
            var buisnessInputs = this.$container.querySelectorAll('.newsletter-form-business-agreement input');
            [...buisnessInputs].forEach((input) => {
                input.removeAttribute('disabled');
            });
        } else {
            this.$newsletterForm.classList.remove('phone-active');
            var buisnessInputs = this.$container.querySelectorAll('.newsletter-form-business-agreement input');
            [...buisnessInputs].forEach((input) => {
                input.setAttribute('disabled', 'disabled');
            });
        }
    }

    submitStep2($form) {
        let formData = new FormData($form);

        for (let $f of $form.querySelectorAll('.error')) {
            $f.classList.remove('error');
            $f.querySelector('input').removeAttribute('aria-invalid');
        }

        axios.post($form.getAttribute('action'), formData).then(response => {
            if (response && response.status === 200) {
                if (response.data.error_code) {
                    this.showErrors($form, response.data);
                } else {
                    this.showThankYou($form);
                }
            }
        });
    }

    showErrors($form, data) {
        for (let name in data.error_messages) {
            if (data.error_messages.hasOwnProperty(name)) {
                let $msg;

                if (name === 'global') {
                    $msg = this.getGlobalError($form);
                    $msg.innerText = data.error_messages.global;
                } else {
                    $msg = this.getFieldError($form, name);
                }

                if ($msg && $msg.length) {
                    for (let $m of $msg) {
                        $m.innerText = data.error_messages[name];
                    }
                }
            }
        }

        let $input = $form.querySelector('.error input:not([type="hidden"])');

        scrollWithOffset($input).then(() => {
            $input.focus();
        })
    }

    getGlobalError($form) {
        return $form.querySelector('.global-error-message');
    }

    getFieldError($form, name) {
        let $inputs;

        if (name === 'category') {
            $inputs = $form.querySelectorAll(`[data-name="category"]:not([type='hidden'])`);
        } else {
            $inputs = $form.querySelectorAll(`[name="${name}"]:not([type='hidden'])`);
        }

        let $input = $inputs[0],
            $field;

        if (!$input) {
            return null;
        }

        if ($inputs.length === 1 || ($input.type !== 'radio' && $input.type !== 'checkbox')) { // nie ustawiamy aria-invalid dla grup
            $input.setAttribute('aria-invalid', 'true');
        }

        $field = $input.closest('.error-wrap');

        if (!$field) {
            $field = $input.closest('.field');
        }

        if (!$field) {
            return null;
        }
        $field.classList.add('error');

        return $field.querySelectorAll('.error-message');
    }

    showThankYou($form) {
        axios.get($form.dataset.thankYou).then(response => {
            if (response && response.status === 200) {
                document.body.classList.add('newsletter-open');
                this.$newsletter.classList.remove('newsletter-full');
                this.$newsletter.classList.add('newsletter-thank-you');
                this.$container.innerHTML = '';
                this.$container.insertAdjacentHTML('beforeend', response.data);

                this.$container.querySelector('.thank-you-close').addEventListener('click', this.close.bind(this));

                this.$status.innerText = 'Zapis na newsletter: sukces';
            }
        });
    }
}

export default Newsletter;
